package com.fireavert.reports_page.reports_page.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class DeviceToEventRatioRequest(
    val propertyId: Int?,
    val eventDeviceType: String
)
